<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<p class="Other-Books-By-Main-Title">Other Books by Amanda Scott</p>
<p class="Other-Books-By-Titles ParaOverride-1"><span class="CharOverride-3"><b>Series</b></span></p>
<p class="Other-Books-By-Subtitles">THE BATH TRILOGY</p>
<p class="Other-Books-By">The Bath Quadrille</p>
<p class="Other-Books-By">Bath Charade</p>
<p class="Other-Books-By">The Bath Eccentric’s Son</p>
<p class="Other-Books-By-Subtitles">BORDER NIGHTS</p>
<p class="Other-Books-By">Moonlight Raider</p>
<p class="Other-Books-By">Devil’s Moon</p>
<p class="Other-Books-By-Subtitles">THE BORDER TRILOGY</p>
<p class="Other-Books-By">Border Bride</p>
<p class="Other-Books-By">Border Fire</p>
<p class="Other-Books-By">Border Storm</p>
<p class="Other-Books-By-Subtitles">THE BORDER TRILOGY 2</p>
<p class="Other-Books-By">Border Wedding</p>
<p class="Other-Books-By">Border Lass</p>
<p class="Other-Books-By">Border Moonlight</p>
<p class="Other-Books-By-Subtitles">THE DANGEROUS SERIES</p>
<p class="Other-Books-By">Dangerous Games</p>
<p class="Other-Books-By">Dangerous Angels</p>
<p class="Other-Books-By">Dangerous Illusions</p>
<p class="Other-Books-By">Dangerous Lady</p>
<p class="Other-Books-By-Subtitles">THE GALLOWAY TRILOGY</p>
<p class="Other-Books-By">Tamed by a Laird</p>
<p class="Other-Books-By">Seduced by a Rogue</p>
<p class="Other-Books-By">Tempted by a Warrior</p>
<p class="Other-Books-By-Subtitles">THE HIGHLAND SERIES</p>
<p class="Other-Books-By">Highland Fling</p>
<p class="Other-Books-By">Highland Secrets</p>
<p class="Other-Books-By">Highland Treasure</p>
<p class="Other-Books-By">Highland Spirits</p>
<p class="Other-Books-By-Subtitles">THE ISLES/TEMPLARS SERIES</p>
<p class="Other-Books-By">Highland Princess</p>
<p class="Other-Books-By">Lord of the Isles</p>
<p class="Other-Books-By">Prince of Danger</p>
<p class="Other-Books-By">Lady’s Choice</p>
<p class="Other-Books-By">Knight’s Treasure</p>
<p class="Other-Books-By">King of Storms</p>
<p class="Other-Books-By-Subtitles">LAIRDS OF THE LOCH</p>
<p class="Other-Books-By">The Laird’s Choice</p>
<p class="Other-Books-By">The Knight’s Temptress</p>
<p class="Other-Books-By">The Warrior’s Bride</p>
<p class="Other-Books-By-Subtitles">SCOTTISH KNIGHTS TRILOGY</p>
<p class="Other-Books-By">Highland Master</p>
<p class="Other-Books-By">Highland Hero</p>
<p class="Other-Books-By">Highland Lover</p>
<p class="Other-Books-By-Subtitles">THE SECRET CLAN</p>
<p class="Other-Books-By">Abducted Heiress</p>
<p class="Other-Books-By">Hidden Heiress</p>
<p class="Other-Books-By">Highland Bride</p>
<p class="Other-Books-By">Reiver’s Bride</p>
<p class="Other-Books-By-Titles"><span class="CharOverride-3"><b>Novels</b></span></p>
<p class="Other-Books-By">An Affair of Honor</p>
<p class="Other-Books-By">The Battling Bluestocking</p>
<p class="Other-Books-By">The Bawdy Bride</p>
<p class="Other-Books-By">The Dauntless Miss Wingrave</p>
<p class="Other-Books-By">The Fugitive Heiress</p>
<p class="Other-Books-By">The Indomitable Miss Hariss</p>
<p class="Other-Books-By">The Infamous Rakes</p>
<p class="Other-Books-By">The Kidnapped Bride</p>
<p class="Other-Books-By">Lady Escapade</p>
<p class="Other-Books-By">Lady Hawk’s Folly</p>
<p class="Other-Books-By">Lord Abberley’s Nemesis</p>
<p class="Other-Books-By">Lord Greyfalcon’s Reward</p>
<p class="Other-Books-By">The Madcap Marchioness</p>
<p class="Other-Books-By">Mistress of the Hunt</p>
<p class="Other-Books-By">The Rose at Twilight</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title" id="title"><span class="CharOverride-4">The Reluctant Highlander</span></p>
<p class="ORIM-Book-Subtitle"><span class="CharOverride-5">A Highland Romance</span></p>
<p class="ORIM-Author-Name">Amanda Scott</p>
<p class="ORIM-Author-Name"><img alt="logo" src="image/logo2.jpg"/></p>
<p class="ORIM-Dedication _idGenParaOverride-1" id="ded"><em class="italic _idGenCharOverride-1">To Tom &amp; Kathleen Fashinell,<br/>two very special friends,<br/>for always being there, again &amp; again.<br/>Thank You!</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?5cb98946